import {isNil} from 'ramda';

import {PdfExportError} from 'features/pdf-export';

import type {GridPdfExportContext} from '../types/GridPdfExportContext';
import type {GridPdfExportRequest} from '../types/GridPdfExportRequest';
import type {RowData} from '../types/RowData';

/** Require the captured selection in full. The endpoint returns a page, not an ID-filtered snapshot. */
export function prepareGridPdfExport(
  request: GridPdfExportRequest,
  rows: readonly RowData[]
): GridPdfExportContext {
  const selectedIds = new Set(request.recordIds);
  const selectedRows = new Map<string, RowData>();
  for (const row of rows) {
    if (!selectedIds.has(row.id)) {
      continue;
    }
    if (
      selectedRows.has(row.id) ||
      request.requiredColumns.some((key) => !Object.hasOwn(row, key))
    ) {
      throw new PdfExportError(
        'module.reportDocument.labels.dataUnavailable',
        false,
        'entity.integration.labels.pleaseRefresh'
      );
    }
    selectedRows.set(row.id, row);
  }
  const orderedRows = request.recordIds.map((id) => {
    const row = selectedRows.get(id);
    if (isNil(row)) {
      throw new PdfExportError(
        'module.reportDocument.labels.dataUnavailable',
        false,
        'entity.integration.labels.pleaseRefresh'
      );
    }
    return {
      id: row.id,
      cells: Object.fromEntries(request.requiredColumns.map((key) => [key, row[key]])),
    };
  });
  return structuredClone({
    rows: orderedRows,
    columns: request.columns,
    exportedAt: request.exportedAt,
  });
}
